import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class SanitizerService {
  /***************Constructor***************/
  constructor(
    private sanitizer: DomSanitizer
  ) { }
  /***************Constructor***************/

  /***************Helper Methods***************/
  
  sanitizeUrl(url) {
    return this.sanitizer.sanitize(SecurityContext.URL, url);
  }

  sanitizeHtml(msg) {
    return this.sanitizer.sanitize(SecurityContext.HTML, msg);
  }

  /***************Helper Methods***************/
}
